import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportInventoryCrumb } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getInventoryLevel, getInventorySnapShot, getProductVelocity, getPriceTracker, getTHCCBDTracker, getCsvReport } from 'actions/ReportsAction';
import { clearProductList } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class InventoryLevel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 9999,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this);
        this.inventory = [];
        this.fixInventory = [];
        this.chartLength = 0;
        this.priceTrackerData = [];
        this.thc = [];
        this.cbd = [];
        this.thclist = [];
        this.cbdlist = [];
    }


    componentWillMount() {
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `InventoryLevelBeginDate`);
        this.props.formInput(date, `InventoryLevelEndDate`);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.inventory && newProps.inventory != this.props.inventory && newProps.inventorySnapShot.length > 0 ||
            (newProps.inventorySnapShot && newProps.inventorySnapShot != this.props.inventorySnapShot && newProps.inventory.length > 0)) {
            let initSumQty = newProps.inventorySnapShot[0].storageQuantity + newProps.inventorySnapShot[0].storeQuantity;
            console.log("inventory:", newProps.inventory);
            this.inventory = newProps.inventory;
            this.fixInventory = [];
            this.chartLength = moment(this.props.endDate).diff(this.props.startDate, 'days');
            let startDate = moment(this.props.endDate).format('YYYY-MM-DD');
            let inventoryIndex = 0;
            this.inventory.filter(x => x.changedDate = moment(x.changedDate).format('YYYY-MM-DD'));
            for (let i = 0; i < this.chartLength; i++) {
                let model = {
                    productName: newProps.inventorySnapShot[0].productName,
                    categoryName: newProps.inventorySnapShot[0].categoryName,
                    classOfCannabis: newProps.inventorySnapShot[0].classOfCannabis,
                    changedDate: moment(startDate).format('MMMM D YYYY'),
                    quantity: initSumQty
                }
                this.fixInventory.push(model);
                if (this.inventory[inventoryIndex] != undefined && this.inventory[inventoryIndex].changedDate == startDate) {
                    initSumQty = initSumQty - this.inventory[inventoryIndex].sumChangedQty;
                    inventoryIndex++;
                }
                startDate = moment(startDate).subtract(1, 'day').format('YYYY-MM-DD');
            }
            this.fixInventory.filter(x => x.changedDate = moment(x.changedDate).format('MMMM D YYYY'));
            this.fixInventory.reverse();
        }
        if (newProps.priceTracker && newProps.priceTracker.length > 0 && newProps.priceTracker != this.props.priceTracker && newProps.priceTracker != null && newProps.priceTracker != undefined) {

            this.priceTrackerData = [];
            if (newProps.priceTracker.length > 0);
            {
                let lastprice = 0;

                if (moment(this.props.startDate).diff(moment(newProps.priceTracker[0].createdDate), 'days') > 0) {
                    if (newProps.priceTracker[0].Type == 1) lastprice = newProps.priceTracker[0].OldPrice;
                }

                let days = moment(this.props.endDate).diff(moment(this.props.startDate), 'days');

                for (let i = 0; i <= days; i++) {
                    //if there is more then one data point on the same day, use the last data point
                    let data = newProps.priceTracker.filter(x => moment(x.createdDate).startOf('day').isSame(moment(this.props.startDate).add(i, 'day'))).sort((a, b) => a.createdDate < b.createdDate ? 1 : -1);

                    if (data == null || data.length == 0) {//use the last value if no data for this day
                        this.priceTrackerData.push({ date: moment(this.props.startDate).add(i, 'day').format('MMMM D YYYY'), price: lastprice });
                    }
                    else {
                        let assignedPrice = data[0].newPrice;
                        lastprice = assignedPrice;//save for use as last value in future data point
                        this.priceTrackerData.push({ date: moment(this.props.startDate).add(i, 'day').format('MMMM D YYYY'), price: assignedPrice });
                    }
                }
            }
        }
        if (newProps.tHCCBDTracker && newProps.tHCCBDTracker != this.props.tHCCBDTracker && newProps.tHCCBDTracker != null && newProps.tHCCBDTracker != undefined) {
            this.thclist = newProps.tHCCBDTracker.thc;
            this.cbdlist = newProps.tHCCBDTracker.cbd;
        }
    }

    componentWillUnmount() {
        this.props.clearProductList();
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    getReport = () => {
        let modelForSnapShot = {
            branch: this.props.branchId,
            selectedDate: moment().format('YYYY-MM-DD'),
            productId: this.props.selectProductId || 0,
            pageNumber: 1,
            pageSize: 99,
            category: 0,
            iscannabis: 2,
            weight: 0,
            species: 0
        }
        this.props.getInventorySnapShot(modelForSnapShot);
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let startDate = this.props.startDate || moment().format("YYYY-MM-DD");
        let endDate = this.props.endDate || moment().format("YYYY-MM-DD");
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let category = this.props.categoryFilter || 0;
        let productId = this.props.selectProductId || 0;
        this.sleep(500).then(() => {
            this.props.getInventoryLevel({ branch, startDate, endDate, category, productId, pageNumber, pageSize });
        });
        this.sleep(500).then(() => {
            this.props.getProductVelocity({ branch, startDate, endDate, productId });
        });
        if (this.props.TrackProductChange) {
            this.props.getPriceTracker({ branch, startDate, endDate, productId, pageNumber, pageSize });
            this.props.getTHCCBDTracker({ branch, startDate, endDate, productId, pageNumber, pageSize });
        }
    }

    downloadInventory = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let pageNumber = 1;
        let pageSize = 9999;
        let startDate = this.props.startDate;
        let endDate = this.props.endDate;
        let category = this.props.categoryFilter || 0;
        let productId = this.props.selectProductId || 0;

        if (checkDateRange(startDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/inventorylevel?branch=${branch}&startDate=${startDate}&endDate=${endDate}&category=${category}&productId=${productId}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "inventorylevel");
        }
    }

    downloadPriceHistory = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let pageNumber = 1;
        let pageSize = 9999;
        let startDate = this.props.startDate;
        let endDate = this.props.endDate;
        let productId = this.props.selectProductId || 0;
        console.log(endDate);
        this.props.getCsvReport(`reports/excel/productpricehistory?branch=${branch}&startDate=${startDate}&endDate=${endDate}&productId=${productId}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "productpricehistory");
    }

    downloadTHC = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let pageNumber = 1;
        let pageSize = 9999;
        let startDate = this.props.startDate;
        let endDate = this.props.endDate;
        let productId = this.props.selectProductId || 0;
        console.log(endDate);
        this.props.getCsvReport(`reports/excel/productthchistory?branch=${branch}&startDate=${startDate}&endDate=${endDate}&productId=${productId}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "productthchistory");
    }

    downloadCBD = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let pageNumber = 1;
        let pageSize = 9999;
        let startDate = this.props.startDate;
        let endDate = this.props.endDate;
        let productId = this.props.selectProductId || 0;
        console.log(endDate);
        this.props.getCsvReport(`reports/excel/productcbdhistory?branch=${branch}&startDate=${startDate}&endDate=${endDate}&productId=${productId}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "productcbdhistory");
    }

    getProductOptions = () => {
        return (this.props.products || []).map(item => {
            return {
                text: item.name,
                value: item.id,
                categoryId: item.categoryId
            };
        });
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    cleanSearch = () => {
        this.props.clearFormInput(`InventoryLevelWarehouse`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    render() {
        //const totalRow = this.props.inventorySummary? this.props.inventorySummary.length > 0 ? this.props.inventorySummary[0].totalrow : 0 : 0;
        console.log("new fixed inven:", this.fixInventory);
        return (
            <Grid headerContent={reportInventoryCrumb}>
                <PageHeader 
                    title={LOOKUP.report.inventoryLevel.text} 
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-product-velocity-report" />}
                    description={LOOKUP.report.inventoryLevel.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    downloadInventory={this.downloadInventory}
                    showBody={this.showBody}
                    products={this.getProductOptions()}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body inventorySummary={this.fixInventory} productVelocity={this.props.productVelocity} priceTracker={this.props.priceTracker}
                            priceTrackerGraphData={this.priceTrackerData} beginDate={this.props.beginDate} endDate={this.props.endDate} priceTrackerCheck={this.props.priceTrackerCheck}
                            thclist={this.thclist} cbdlist={this.cbdlist} THCTrackerCheck={this.props.tHCTrackerCheck} CBDTrackerCheck={this.props.cBDTrackerCheck}
                            downloadPrices={this.downloadPriceHistory} downloadTHC={this.downloadTHC} downloadCBD={this.downloadCBD} TrackProductChange={this.props.TrackProductChange} />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        branchId: state.common.branchId,
        inventorySummary: state.reports.inventoryLevel,
        loggedBranch: state.common.branchId,
        selectedBranch: state.form.InventoryLevelBranchOption,
        warehouse: state.form.InventoryLevelWarehouse,
        beginDate: state.form.InventoryLevelBeginDate,
        startDate: moment(state.form.InventoryLevelBeginDate).format("YYYY-MM-DD"),
        categoryFilter: state.form.InventoryLevelProductIdCategoryId,
        selectProductId: state.form.InventoryLevelProductId,
        products: state.entity.productList,
        productVelocity: state.reports.productVelocity,
        endDate: moment(state.form.InventoryLevelEndDate).format("YYYY-MM-DD"),
        inventory: state.reports.inventoryLevel || [],
        inventorySnapShot: state.reports.inventorySnapShot || [],
        priceTracker: state.reports.priceTracker,
        priceTrackerCheck: state.form.InventoryLevelPriceHistory || false,
        tHCTrackerCheck: state.form.InventoryLevelTHCHistory || false,
        cBDTrackerCheck: state.form.InventoryLevelCBDHistory || false,
        tHCCBDTracker: state.reports.tHCCBDTracker,
        TrackProductChange: state.common.applicationSettings.trackProductChange
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getInventoryLevel: (model) => dispatch(getInventoryLevel(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getInventorySnapShot: (model) => dispatch(getInventorySnapShot(model)),
        getProductVelocity: (model) => dispatch(getProductVelocity(model)),
        getPriceTracker: (model) => dispatch(getPriceTracker(model)),
        getTHCCBDTracker: (model) => dispatch(getTHCCBDTracker(model)),
        showError: (message) => dispatch(showError(message)),
        clearProductList: () => dispatch(clearProductList()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(InventoryLevel));